
export default host => channelId => `${host}/contentCreations/communities/${channelId}/export`
    